import React from 'react';
import { motion } from 'framer-motion';
import { LightningIcon } from './Icons';
export function WhatsInside() {
  const items = ['Ejercicio para detectar tu bloqueo financiero en el cuerpo', 'Checklist para identificar tu tipo de autosabotaje', 'Ejercicio para cortar la reacción automática al dinero en segundos', 'Ejercicios diarios para cambiar cómo reaccionas', 'Ejercicio guiado para cambiar cómo piensas y sientes sobre el dinero', 'Sistema completo paso a paso (mañana, día y noche)', 'Método para dejar de perder dinero cuando llega'];
  return <section className="bg-primary py-10 md:py-16 px-4 md:px-12" data-id="element-307">
      <div className="max-w-3xl mx-auto" data-id="element-308">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 md:mb-12" data-id="element-309">
          <h2 className="font-playfair font-bold text-3xl md:text-5xl text-warm-white mb-4" data-id="element-310">
            Esto es lo que vas a hacer exactamente:
          </h2>
          <p className="font-inter text-base md:text-lg text-warm-muted leading-relaxed" data-id="element-311">
            Un sistema guiado de 21 días donde cada día tienes pasos claros. No
            tienes que pensar. Solo seguir.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-secondary border border-gold rounded-2xl p-6 md:p-10 shadow-glow-gold mb-8" data-id="element-312">
          <div className="font-inter font-bold text-gold tracking-widest mb-6 text-center" data-id="element-313">
            INCLUYE:
          </div>
          <ul className="space-y-4" data-id="element-314">
            {items.map((item, idx) => <li key={idx} className="flex items-start gap-3" data-id="element-315">
                <LightningIcon className="w-5 h-5 text-gold flex-shrink-0" data-id="element-316" />
                <span className="font-inter text-warm-white text-base md:text-lg" data-id="element-317">
                  {item}
                </span>
              </li>)}
          </ul>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-318">
          <p className="font-playfair italic text-xl md:text-2xl text-gold" data-id="element-319">
            Todo explicado simple. Sin teoría innecesaria.
          </p>
        </motion.div>
      </div>
    </section>;
}